<template>
  <div>
    <el-row type="flex" justify="center">
      <el-col :sm="{ span: 12}">
        <use-card v-loading="sortedUses.length === 0" :uses="sortedUses" @select="handleSelectUse"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import UseCard from '@/components/uses/UseCards'
import { mapGetters } from 'vuex'

export default {
  name: 'recipes',
  props: ['useId'],
  data() {
    return {}
  },
  methods: {
    handleSelectUse(item) {
      this.$router.push({ path: '/useCatagories/' + item.Id })
    }
  },
  components: {
    UseCard
  },
  computed: {
    ...mapGetters(['uses']),
    sortedUses() {
      return this.uses.slice().sort((a, b) => a.Name.localeCompare(b.Name))
    }
  }
}
</script>
<style scoped>
